import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import LogoCartoes from '../../assets/img/cartoes_cinza.svg';
import LogoGoDaddy from '../../assets/img/godaddy_cinza.svg';
import LogoFaceBook from '../../assets/img/facebook_cinza.svg';
import LogoInstagram from '../../assets/img/instagram_cinza.svg';
import LogoYoutube from '../../assets/img/youtube_cinza.svg';
import LogoTwitter from '../../assets/img/twitter_cinza.svg';

import { Typography } from '@mui/material';

import { color } from '@mui/system';
import Menu_Rodape from '../Menu_Rodape/Menu_Rodape';
import { BrowserView, MobileView } from 'react-device-detect';

function Rodape() {
    return (
        <div>
            <BrowserView>
                <Grid container columns={{ xs: 1, sm: 8, md: 12 }} sx={{ bgcolor: '#EAFAF1', padding: '5px', borderTop: 1, borderColor: '#D2D3D7' }}>
                    <Grid item xs={1} md={2} inline variant="body1" align="left" paddingLeft={'20px'}>
                        <Box>
                            <img src={LogoNafil} alt="NAFIL" width={null} sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '100px', height: 'auto' }} />
                        </Box>
                        <Box>
                            <Typography fontSize={'11px'} xs={{ alignContent: 'center', alignItems: 'center', marginLeft: '30px' }} md={{ alignContent: 'left', alignItems: 'left' }}>
                                CNPJ: 32.516.544/0001-05<br />
                                NAFIL AUTO PEÇAS EIRELI<br />
                                AV. Presbiteriana, 464<br />
                                Vila Mury<br />
                                Volta Redonda - RJ<br />
                                CEP: 27281-510
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={1} md={6} align='left' sx={{ alignItems: 'left', alignContent: 'flex-start', paddingRight: '0', fontSize: { xs: '12px', md: '14px' }, lineHeight: '24px' }}>
                        <Menu_Rodape />
                    </Grid>

                    <Grid item xs={1} md={4} sx={{ paddingRight: '0', paddingTop: '20px' }}>
                        <img src={LogoCartoes} alt="Cartões" width={null} sx={{ display: { xs: 'none', md: 'flex' } }} />
                        <Box>
                            <b style={{ color: '#FF0000', margin: '0', marginTop: '18px', fontSize: { xs: '7px', md: '15px' } }}>Compre em Até 10x Sem Juros nos Cartões de Créditos*</b>
                        </Box>
                        <Box sx={{ marginTop: '10px' }}>
                            <img src={LogoInstagram} alt="Cartões" width="28px" height="28px" style={{ marginTop: '-50px' }} />
                            <img src={LogoFaceBook} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoTwitter} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoYoutube} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoGoDaddy} alt="Cartões" width="100px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                        </Box>
                    </Grid>
                </Grid>
            </BrowserView>

            <MobileView>
                <Grid container columns={{ xs: 1, sm: 8, md: 12 }} sx={{ bgcolor: '#EAFAF1', padding: '5px', borderTop: 1, borderColor: '#D2D3D7' }}>
                    <Grid item xs={1} md={2} inline variant="body1" align="left" paddingLeft={'20px'}>
                        <Box>
                            <img src={LogoNafil} alt="NAFIL" width={null} style={{ width: '180px', height: 'auto' }} />
                        </Box>
                        <Box>
                            <Typography fontSize={'15px'} xs={{ fontSize: '2px', alignContent: 'center', alignItems: 'center', marginLeft: '30px' }} md={{ fontSize: '4px', alignContent: 'left', alignItems: 'left' }}>
                                CNPJ: 32.516.544/0001-05<br />
                                NAFIL AUTO PEÇAS EIRELI<br />
                                AV. Presbiteriana, 464<br />
                                Vila Mury<br />
                                Volta Redonda - RJ<br />
                                CEP: 27281-510
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item fontSize={'15px'} xs={1} md={6} align='left' sx={{ alignItems: 'left', alignContent: 'flex-start', paddingRight: '0', lineHeight: '48px' }}>
                        <Menu_Rodape />
                    </Grid>

                    <Grid item xs={1} md={4} sx={{ paddingRight: '0' }}>
                        <img src={LogoCartoes} alt="Cartões" width={null}  />
                        <Box fontSize={'20px'}>
                            <b style={{ color: '#FF0000', margin: '0', marginTop: '-1px'}}>Compre em Até 10x Sem Juros nos<br/>Cartões de Créditos*</b>
                        </Box>
                        <Box sx={{ marginTop: '20px' }}>
                            <img src={LogoInstagram} alt="Cartões" width="28px" height="28px" style={{ marginTop: '-50px' }} />
                            <img src={LogoFaceBook} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoTwitter} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoYoutube} alt="Cartões" width="28px" height="28px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                            <img src={LogoGoDaddy} alt="Cartões" width="100px" sx={{ paddingLeft: '5px', display: { xs: 'none', md: 'flex' } }} style={{ marginLeft: '15px', marginTop: '-10px' }} />
                        </Box>
                    </Grid>
                </Grid>
            </MobileView>
        </div>
    )
}
export default Rodape   